import React from 'react';
import moment from 'moment';
import CircularIndicator from '../common/indicators/circularIndicator';

const colorCircular = risk => {
  const obj = {
    higherRisk: [],
    middleRisk: [],
    outOfRisk: []
  };
  if (risk.toUpperCase() === 'LOWRISK') {
    obj.outOfRisk.push(0, 100);
    obj.middleRisk.push(-1, -1);
    obj.higherRisk.push(-1, -1);
  } else if (risk.toUpperCase() === 'MIDDLERISK') {
    obj.outOfRisk.push(-1, -1);
    obj.middleRisk.push(0, 100);
    obj.higherRisk.push(-1, -1);
  } else if (risk.toUpperCase() === 'HIGHRISK') {
    obj.outOfRisk.push(-1, -1);
    obj.middleRisk.push(-1, -1);
    obj.higherRisk.push(0, 100);
  }

  return obj;
};

const Circular = props => {
  return (
    <div className="container-circular driver">
      <div className="circular-graph-line ">
        <a className="stop">
          <div className="box-circular">
            <CircularIndicator
              size={110}
              max={100}
              value={props.currentFatigueLevelValue}
              forceValue={100}
              fill
              id={'circle1'}
              valueFormat={{ type: 'NUMBER', format: '.0f', sufix: '' }}
              graphColorRange={colorCircular(props.inRisk.value.risk)}
            />
          </div>
        </a>
      </div>
      <h3>
        {props.language.detail_fatigue.nfa.fatigueLevel} <br />
        (2018-03-20)
      </h3>
    </div>
  );
};
export default Circular;



// WEBPACK FOOTER //
// ./source/client/components/driver_nfa/circularNfa.jsx